/* global Swiper */
(() => {
  const themeCreateProductSwiper = () => {
    if (!customElements.get('product-swiper')) {
      class ProductSwiper extends HTMLElement {
        connectedCallback() {
          const fullWidth = this.dataset.fullWidth === 'true';
          const centeredSlides = this.dataset.centered !== 'false';
          const nextBtn = this.querySelector('.slider-nav__btn[name=next]');
          const prevBtn = this.querySelector('.slider-nav__btn[name=prev]');
          const nextSlideMessage = nextBtn?.getAttribute('aria-label') || 'Next slide';
          const prevSlideMessage = prevBtn?.getAttribute('aria-label') || 'Previous slide';
          
          // Default breakpoints
          let breakpoints = {
            // when window width is >= 768px
            768: {
              slidesPerView: 3,
              spaceBetween: this.dataset.effect === 'coverflow' ? 80 : 24
            },
            1120: {
              slidesPerView: 4,
              spaceBetween: this.dataset.effect === 'coverflow' ? 80 : 24
            },
            1400: {
              slidesPerView: 5,
              spaceBetween: this.dataset.effect === 'coverflow' ? 80 : 24
            }
          };
          
          // Allow custom breakpoints via data attribute
          if (this.dataset.breakpoints) {
            try {
              breakpoints = JSON.parse(this.dataset.breakpoints);
            } catch (e) {
              console.warn('Invalid breakpoints JSON:', e);
            }
          }
          
          this.swiper = new Swiper(`#${CSS.escape(this.id)} .swiper`, {
            grabCursor: true,
            simulateTouch: true,
            allowTouchMove: true,
            centeredSlides: centeredSlides,
            slidesPerView: 1,
            spaceBetween: this.dataset.effect === 'coverflow' ? 50 : 20,
            speed: 600,
            effect: this.dataset.effect || 'slide',
            breakpoints: breakpoints,
            loop: this.dataset.noLoop !== 'true',
            loopAdditionalSlides: this.dataset.noLoop === 'true' ? 0 : 5,
            resizeObserver: false,
            // Allow swiping even when starting on interactive elements (links, buttons)
            noSwiping: false,
            noSwipingClass: 'swiper-no-swiping',
            // Allow swiping on product cards and their children
            swipeHandler: null,
            coverflowEffect: {
              rotate: 0,
              stretch: 0,
              depth: 200,
              scale: 1,
              modifier: 1,
              slideShadows: false
            },
            navigation: {
              nextEl: `#${CSS.escape(this.id)} .slider-nav__btn[name=next]`,
              prevEl: `#${CSS.escape(this.id)} .slider-nav__btn[name=prev]`
            },
            a11y: {
              slideRole: null,
              prevSlideMessage,
              nextSlideMessage
            },
            on: {
              init: fullWidth ? null : this.updateEdgeSlideVisibility,
              slideChange: fullWidth ? null : this.updateEdgeSlideVisibility
            }
          });

          this.swiper.on('init', () => {
            this.updateSlideTabIndex();
            if (this.swiper.navigation) {
              if (nextBtn && prevBtn) {
                this.swiper.navigation.init();
                this.swiper.navigation.update();
              }
            }
          });
          this.swiper.on('slideChange', this.updateSlideTabIndex.bind(this));
        }

        updateSlideTabIndex() {
          this.swiper.slides.forEach((slide, index) => {
            const focusableElements = slide.querySelectorAll(
              'product-card, a, button, input, textarea, select, [tabindex]'
            );
            if (index === this.swiper.activeIndex) {
              slide.removeAttribute('tabindex');
              focusableElements.forEach((el) => el.removeAttribute('tabindex'));
            } else {
              slide.setAttribute('tabindex', '-1');
              focusableElements.forEach((el) => el.setAttribute('tabindex', '-1'));
            }
          });
        }

        updateEdgeSlideVisibility() {
          this.slides.forEach((slide) => slide.classList.remove('is-visible'));

          const { activeIndex } = this;
          const { slidesPerView } = this.params;
          let range;
          if (slidesPerView <= 1) {
            range = 0;
          } else if (slidesPerView <= 3) {
            range = 1;
          } else if (slidesPerView <= 4) {
            range = 2;
          } else {
            range = 3;
          }

          for (let i = -range; i <= range; i += 1) {
            const index = (activeIndex + i + this.slides.length) % this.slides.length;
            this.slides[index].classList.add('is-visible');
          }
        }
      }

      customElements.define('product-swiper', ProductSwiper);
    }
  };

  window.theme = window.theme || {};

  if (theme.Swiper || typeof Swiper !== 'undefined') {
    if (!theme.Swiper && typeof Swiper !== 'undefined') {
      theme.Swiper = Swiper;
    }
    themeCreateProductSwiper();
  } else {
    document.addEventListener('swiper-loaded', function () {
      if (!theme.Swiper && typeof Swiper !== 'undefined') {
        theme.Swiper = Swiper;
      }
      themeCreateProductSwiper();
    });
  }
})();
